module.exports = __webpack_public_path__ + "static/media/flag-bho.4cece025.webp";